export default "__VITE_ASSET__2d9b168d__"